const en = {
	loading : `Loading…`,
	pause : `Pause`,
	play : `Play`,
	canonical : `Link to the sound's page`,
	moment : `Link to this time`,

	untitled : `(untitled)`,
	cover : `cover`,
	more : `Actions`,
	share : `Share`,
	twitter : `Share on Twitter`,
	facebook : `Share on Facebook`,
	e_mail : `Share via e-mail`,
	download : `Download`,
	back : `Back`,

	chapters : `Chapters`,
	playlist : `Playlist`,

	media_err_aborted : `You have aborted the play.`,
	media_err_network : `A network error broke the download.`,
	media_err_decode : `Play was canceled due to file corruption or a not supported function in your browser.`,
	media_err_src_not_supported : `The media cannot be downloaded due to server problems, network problems or unsupported by your browser.`,
	media_err_unknow : `Error of unknown cause.`
};

export default en;